import useData from "./useData";

const useLocation = () => {
  const { getFromServer, executeAction, updateRecord } = useData();

  const getLocationById = async (locationId) => {
    const data = await getFromServer({
      entityName: "Location",
      id: locationId,
    });

    return data;
  };

  const getProjectLocation = async (projectId, locationId) => {
    const results = await executeAction({
      entityName: "ProjectLocation",
      action: "getProjectLocation",
      data: {
        projectId,
        locationId,
      },
    });

    return results?.isSuccessful ? results.data : null;
  };

  const updateProjectLocation = async (data) => {
    const results = await updateRecord("ProjectLocation", data, true);
  };

  return {
    getLocationById,
    getProjectLocation,
    updateProjectLocation,
  };
};

export default useLocation;
